<template>
  <div />
</template>

<script>
export default {
    name: 'LineItemTotals',
    props: ['order']
}
</script>